module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.pageLoading),
      expression: "pageLoading"
    }]
  }, [_c('el-form', {
    ref: "form",
    staticClass: "w-200 m-t-20 m-l-20",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "显示/消失动画时间（秒）",
      "prop": "time"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.time),
      expression: "form.time",
      modifiers: {
        "number": true
      }
    }],
    domProps: {
      "value": (_vm.form.time)
    },
    on: {
      "input": function($event) {
        _vm.form.time = _vm._n($event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "按钮样式"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.style),
      expression: "form.style"
    }],
    attrs: {
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.form.style)
    },
    on: {
      "input": function($event) {
        _vm.form.style = $event
      }
    }
  }, _vm._l((_vm.styles), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否虚化"
    }
  }, [_c('el-switch', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.isOpacity),
      expression: "form.isOpacity"
    }],
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    domProps: {
      "value": (_vm.form.isOpacity)
    },
    on: {
      "input": function($event) {
        _vm.form.isOpacity = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e0af6b4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/page/abstract/box.vue
// module id = 1908
// module chunks = 2